"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ToastMessageComponent = _interopRequireDefault(require("./ToastMessage-component"));

var _reactNativeToastNotifications = require("react-native-toast-notifications");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ToastProvider(props) {
  return /*#__PURE__*/_react.default.createElement(_reactNativeToastNotifications.ToastProvider, {
    placement: "top",
    animationType: "slide-in",
    animationDuration: 400,
    renderToast: options => {
      return /*#__PURE__*/_react.default.createElement(_ToastMessageComponent.default, {
        message: options.message,
        options: {
          actionText: options.data?.actionText,
          action: options.data?.action,
          type: options.data?.type,
          showDismiss: options.data?.showDismiss
        }
      });
    }
  }, props.children);
}

var _default = ToastProvider;
exports.default = _default;